var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useReducer } from "react";
import { TextInput } from "../input";
var defaultState = {
    displayValue: "",
};
var dispatchFn = function (state, action) {
    switch (action.type) {
        case "SET_DISPLAY": {
            return __assign(__assign({}, state), { displayValue: action.payload });
        }
        default:
            return __assign({}, state);
    }
};
var maxValueLength = 16;
var maxDisplayLength = 19;
export var CardInput = function (props) {
    var _a = useReducer(dispatchFn, defaultState), displayValue = _a[0].displayValue, dispatch = _a[1];
    useEffect(function () {
        if (displayValue.replace(/ /g, "") !== props.value.replace(/ /g, "")) {
            var nextDisplay = props.value
                .replace(/[^0-9\s]/g, "")
                .replace(/(\d{4})/g, "$1 ")
                .slice(0, maxDisplayLength);
            dispatch({ type: "SET_DISPLAY", payload: nextDisplay });
        }
    }, [props.value, displayValue]);
    var handleChange = useCallback(function (e) {
        var eventValue = e.target.value;
        eventValue = eventValue.replace(/[^0-9\s]/g, "");
        var nextDisplay;
        if (eventValue.replace(/ /g, "").length % 4 === 0 &&
            eventValue.length !== 0 &&
            eventValue.length > displayValue.length &&
            eventValue.charAt(eventValue.length - 1) !== " ") {
            nextDisplay = eventValue + " ";
        }
        else {
            nextDisplay = eventValue;
        }
        dispatch({ type: "SET_DISPLAY", payload: nextDisplay.slice(0, maxDisplayLength) });
        var nextValue = eventValue.replace(/ /g, "").slice(0, maxValueLength);
        if (props.onCardChange) {
            props.onCardChange(nextValue);
        }
    }, [displayValue.length, props]);
    return React.createElement(TextInput, __assign({}, props, { value: displayValue, onChange: handleChange }));
};
